import { useState, useEffect } from 'react'
import style from './index.module.scss'
import { Menu, Modal, Alert, Dropdown, Tooltip } from 'antd'
import { UnorderedListOutlined } from '@ant-design/icons'
import * as apis from '../../api/user'
import * as networkDisk from '../../api/networkDisk'

import close from './close.png'
import bell from './bell.png'
import type { MenuProps } from 'antd';
import Msg from '../../components/msg/index'
import {
    excellingTopic, reuqestCreatFavorite
} from '../../api/networkDisk'
import MySelf from '../../components/mySelf/index'
import { SocketModule } from '../../modules/socket'
import useStore from '../../store/useStore'
import icon from '../../static/image/icon.png'
import { memosModule } from '../../modules/memos'

interface Props {
    history: any;
}

interface State {
    exitVisible: boolean;
    userInfo: any;
}

const BottomBar = (props: Props) => {
    const [visibleMsg, setVisibleMsg] = useState<boolean>(false);
    const { store, dispatch } = useStore();
    const [state, setState] = useState<State>({
        exitVisible: false,
        userInfo: {}
    });
    const [visibleMy, setVisibleMy] = useState<boolean>(false);

    const [tx, setTx] = useState<any>();
    const [pageType, setPageType] = useState<any>('');
    const [dataList, setDataList] = useState<any>([]);


    useEffect(() => {
        console.log('store.subjectInfo?.catalogueId', store.subjectInfo, store.subjectInfo?.catalogueId)
        const fetchData = async () => {
            let _dataList: any = [];
            if (store.subjectInfo?.catalogueId) {
                await Promise.all(
                    store.subjectInfo?.catalogueId?.map(async (item: any) => {
                        const parent = item.topicId;
                        let res: any = await excellingTopic({ parent });
                        _dataList[item.topicId] = res.data;
                    })
                );
                console.log('_dataList', _dataList)
                setDataList(_dataList);
            }
        };
        fetchData();
    }, [store.subjectInfo.subjectId, store.subjectInfo?.catalogueId?.length > 0])

    useEffect(() => {
        if (store.subjectInfo.subjectId) {
            getDetail(store.subjectInfo.subjectId, 'init')
        }
    }, [store.subjectInfo.subjectId,])

    const init = (obj: any, id: any) => {
        console.log('bottominit', dataList, id)
        let _dataList: any = dataList;
        dataList[id].map(async (item: any) => {
            if (obj.id === item.id) {
                const parent = obj.id
                let res: any = await excellingTopic({ parent });

                _dataList[obj.id] = res.data
                setDataList(_dataList)
            }

        })
    }
    useEffect(() => {
        console.log('history', window.location.hash)
        let type: any = window.location.hash.slice(2)
        if (type.indexOf('/') >= 0) {
            type = type.slice(0, type.indexOf('/'))
        }
        setPageType(type)


    }, [window.location.hash])

    const cardClick = (obj: any, id: any) => {

        if (obj.id !== store.subjectInfo.subjectId) {
            init(obj, id)
            // dispatch({
            //     type: 'SET_SUBJECTINFO',
            //     data: { subjectCatalogue: [], subjectId: obj.id, data: store.subjectInfo.initData }
            // });
            onDeleteListener(store.subjectInfo.subjectId)
            getDetail(obj.id)
            window.location.hash = '#/view'

        }

    }
    //删除当前监听
    const onDeleteListener = async (id: any) => {
        try {
            let res: any = await networkDisk.deleteListener(id)
        } catch (e) { }
    }
    const getDetail = async (id: any, type?: any) => {
        try {
            await memosModule.getDetail(id).then((res) => {
                console.log('res', res)
                if (res.ok) {
                    let subjectInfo = {
                        subjectId: res.data.id,
                        subjectTitle: res.data.subject,
                        subjectCatalogue: res.data.catalogue,
                        total: res.data.memos.length,
                        data: res.data,
                        catalogueId: res.data.catalogueInfo,
                        permissions: res.data.permissions,
                    };
                    if (type != 'init') {
                        dispatch({
                            type: 'SET_SUBJECTINFO',
                            data: { subjectCatalogue: [], subjectId: id, data: subjectInfo }
                        });
                    }

                }
            }).catch((e) => {
                //console.log(e)
            })

        } catch (e: any) {
            //console.log(e.code)

        }
    }
    const hasMore = (item: any, id: any) => {
        const _active = store.subjectInfo?.catalogueId.filter((obj: any) => obj.topicId == item.topicId)
        // console.log(dataList, id, _active, dataList[_active[0].topicId])
        return dataList[_active[0].topicId]?.length > 0 && item.name != "默认主题"


    }

    const getList = (item: any, id: any) => {
        console.log('getList', id, dataList, item)
        const _active = store.subjectInfo?.catalogueId.filter((obj: any) => obj.topicId == item.topicId)

        let _list: any = []
        _list = dataList[_active[0].topicId]
        // console.log('getList', _list, store.subjectInfo)


        if (_list?.length == 0 || !_list) {
            return <></>
        }


        return <div className={style.popCard}>
            {_list.map((ele: any) => {
                return <p key={ele.id} onClick={() => cardClick(ele, id)}>
                    {ele.subject}
                </p>
            })}

        </div>
    }



    return (
        <div className={style.bottomout} >

            <div data-flex='main:justify' className={style.bottom}>
                {(pageType == 'memo' || pageType == 'view' || pageType == 'calendar' || pageType == 'schedule') && <>
                    <div data-flex='main:justify' style={{ width: '100%' }}>
                        <div data-flex='main:left'>
                            {
                                store.subjectInfo?.catalogueId?.map((i: any, index: any) => (
                                    <>
                                        {i &&
                                            <div key={index} style={i.name?.length > 6 ? { width: '120px', flex: '0 0 120px' } : {}} data-flex='main:justify cross:center' className={i.name?.length > 6 ? "sl-ellipsis mr-10 " : "mr-10 "}>
                                                {store.subjectInfo?.subjectCatalogue?.length === 1 ? <>默认主题</> :
                                                    <><span className='mr-10' data-flex='main:justify cross:center'>{index == store.subjectInfo?.subjectCatalogue?.length || index === 0 ? "" : ">"}</span>
                                                        {index == store.subjectInfo?.subjectCatalogue?.length ? '' :
                                                            <Dropdown trigger={['click']} placement="top"
                                                                dropdownRender={() => getList(i, i.topicId)}>

                                                                < span>

                                                                    {(i.name === '默认主题') ? '主题库' : <>{hasMore(i, index) ? <img src={icon} style={{ width: '13px' }} /> : ''}<>

                                                                        {i?.name?.length > 6 ? <Tooltip title={i.name} className='sl-ellipsis' placement="topLeft"  >
                                                                            {i.name}
                                                                        </Tooltip> : <> {i.name}</>}
                                                                    </></>}
                                                                </span>
                                                            </Dropdown>}
                                                    </>}

                                            </div>
                                        }
                                    </>
                                ))
                            }</div>
                        {pageType === 'memo' && <div >
                            <div>共计：{store.subjectInfo?.data?.memos?.length}个便签</div>
                            <div>{store.memosNum > 0 ? `； 已选中${store.memosNum}个便签` : ``}</div>
                        </div>}
                    </div>

                </>}
                <div></div>
                <div data-flex='main:right cross:center' className='pos-r'>

                    <div className={style.bell}
                        onClick={() => {
                            setVisibleMsg(!visibleMsg);
                            dispatch({
                                type: 'SET_BOTTOMBAR_MSG',
                                data: false
                            });
                        }}
                    >
                        {store.bottombarMsg && <div className={style.unread}></div>}
                        <img src={bell} />
                    </div>
                </div>


            </div>

            {/* <Alert message="Success Text" type="success" /> */}
            <Msg visible={visibleMsg} title={''} onClose={() => { setVisibleMsg(false) }}></Msg>

        </div >
    )
}

export default BottomBar